import React, { createContext, useContext, useRef, useState } from 'react';

// Context to share design-related state between CalendarDesign and DesignSidebar
const DesignContext = createContext(null);

export const DesignProvider = ({ children }) => {
    // Store refs for each calendar view's Konva stage
    const stageRefs = useRef({
        day: null,
        week: null,
        month: null,
        year: null,
    });

    // Track the current active view for export
    const [activeView, setActiveView] = useState('month');

    // Register a stage ref for a specific view
    const registerStageRef = (view, ref) => {
        stageRefs.current[view] = ref;
    };

    // Get the current active stage ref
    const getActiveStageRef = () => {
        return stageRefs.current[activeView];
    };

    return (
        <DesignContext.Provider
            value={{
                stageRefs,
                activeView,
                setActiveView,
                registerStageRef,
                getActiveStageRef,
            }}
        >
            {children}
        </DesignContext.Provider>
    );
};

export const useDesignContext = () => {
    const context = useContext(DesignContext);
    if (!context) {
        throw new Error('useDesignContext must be used within a DesignProvider');
    }
    return context;
};

export default DesignContext;
